import React from 'react'
import BottomBar from '../components/BottomBar'
import Content from '../components/Content'
import TopBar from '../components/TopBar'
import { useBottomBar, useTopBar } from '../store/selectors'
import { BackgrounLogo } from './backgroundLogo'
import { MainContainer } from './styles'

export const MainLayout = () => {
  const topBarHidden = useTopBar()?.hidden || false
  const bottomBarHidden = useBottomBar()?.hidden || false

  let offset = 0
  if (!topBarHidden) offset += 16
  if (!bottomBarHidden) offset += 14

  return (
    <div className="vh-100 vw-100 overflow-hidden">
      {!topBarHidden && <TopBar />}
      <MainContainer offset={offset}>
        <Content fullWidth />
      </MainContainer>
      <BackgrounLogo />
      {!bottomBarHidden && <BottomBar />}
    </div>
  )
}

export default MainLayout
